<label
  class="advanced-select"
  [class.invalid]="showError"
  [class.focused]="isFocused"
  [attr.for]="undefined"
  caiTooltip
  [tooltip]="input.value"
  [detectOverflow]="true"
  [target]="input"
>
  <input
    #input
    [placeholder]="label"
    [(ngModel)]="display"
    [class.text-center]="textCenter"
    [class.text-uppercase]="uppercase"
    [class.float-label]="floatLabel"
    (focus)="open(dropdown, input)"
    (click)="open(dropdown, input)"
    (blur)="close()"
    readonly
    [disabled]="isReadonly"
  />
  <span class="toggle-icon" [class.rotate]="isOpen">
    <ng-content select="[toggle-icon]"></ng-content>
  </span>
  <span class="label">{{ label }}</span>
  <ng-template #dropdown>
    <ul class="dropdown" [ngClass]="customClass">
      @if (!!options.length) {
        <cdk-virtual-scroll-viewport
          class="dropdown-inner"
          [style.height.px]="height"
          [style.min-width.px]="minWidth"
          [style.max-width.px]="maxWidth"
          itemSize="30"
        >
          <div *cdkVirtualFor="let option of options; let i = index">
            <div
              class="select-item"
              caiTooltip
              class="item"
              [tooltip]="option.label"
              placement="bottom-start"
              [class.selected]="selected === option"
              (mousedown)="select(option); $event.preventDefault()"
            >
              <span>{{ option.label }}</span>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      }
    </ul>
  </ng-template>
</label>
